<template>
  <div class="about-us-container">
    <div class="about-us-body" type="bottom">
      <div class="about-us-title">
        <div class="main-title wow fadeInUp">
          <span>关于栗鼠</span>
        </div>
        <div class="sub-title wow fadeInUp">
          <span>ABOUT US</span>
        </div>
      </div>
      <div class="about-us-introduce wow fadeInUp">
        <span
          >杭州栗鼠科技有限公司成立于2015年，是一家专业的软件制作策划公司。公司主要服务于中小医院，提供软件制作，网站设计制作建设，网络推广营销于一体的专业服务。公司以“创新”为核心价值，希望通过我们的专业水平和不懈努力，重塑中小医院的软件革新及网络形象，为企业产品推广，文化建设传播提供服务指导。</span
        >
      </div>
      <div class="about-us-logo">
        <img
          class="wow fadeInDown"
          src="@/assets/images/about-us-logo.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.about-us-container {
  margin-top: 80px;
  height: 265px;
  border-top: 1px solid #e9eef5;
  position: relative;
  .about-us-body {
    width: 1050px;
    margin: 0 auto;
    height: 265px;
    display: flex;
    align-items: center;
    .about-us-title {
      margin-right: 5%;
      .main-title {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
      }
      .sub-title {
        font-family: PingFangSC-Light;
        font-size: 24px;
        color: #c4cad6;
      }
    }
    .about-us-introduce {
      width: 50%;
      margin-right: 10%;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #3c3d3f;
      line-height: 28px;
    }
    .about-us-logo {
      transform: translateY(-50px) !important;
      // position: absolute;
      // right: 0;
      img {
        height: 200px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/aboutUs.vue